import { ModalChiTietHopDong } from "components/NhanVay/ChiTietHopDong/ModalChiTietHopDong";
import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import ChiTietHopDong from "../../../../service/chiTietHopDongApi";
// import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
export const BtnChiTietHopDong = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <a onClick={handleShow} href={() => false} className="blue btn-link">
        {item.Code}
      </a>
      {show && (
        <ModalChiTietHopDong
          show={show}
          onHide={handleClose}
          nhanvayId={item.NhanVayID}
        />
      )}

      {/* {showChiTietHopDong && (
        <ChiTietHopDongContainer
          show={handleShowChiTietHopDong}
          onHide={handleCloseChiTietHopDong}
          data={chovayChiTiet}
          setModalTaiSan={handleShowChiTietHopDong}
        ></ChiTietHopDongContainer>
      )} */}
    </>
  );
};
